var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "product-show-view-wrapper" } },
    [
      _vm.initialized
        ? [
            _c("ci-view-product-funds", {
              attrs: {
                product: _vm.product,
                "peergroup-ranking": _vm.peergroupRanking,
                "peergroup-size": _vm.peergroupSize,
              },
            }),
          ]
        : _vm._e(),
      _c("ci-registration-modal", {
        attrs: {
          "gating-banner-location": "product",
          "onboarding-type": "gating-banner",
          "return-button-text":
            "ui.components.users.onboarding.register.back_to_product",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }